export const generateStorageKey: (string) => string = (userId: string) => {
  return `keyDoNotDisturb-${userId}`;
};
